<app-spinner [blockedPanel]="blockedPanel"></app-spinner>
<!-- Modal -->
<div class="formModal" *ngIf="!blockedPanel" style="z-index: 105001 !important">
  <button class="d-flex justify-content-center" mat-raised-button color="warn" (click)="hideAssetModal()" style="width: 20px; min-width: 20px; height: 36px; float: right">&#10005;</button>
  <form [formGroup]="assetForm">
    <div class="row mt-3 form-header sticky-header">
      <h3 class="font-weight-bold">
        {{ "ADD ASSET" | translate }}
      </h3>
    </div>

    <div class="row mt-5">
      <div class="col-8">
        <div class="row">
          <ng-container formGroupName="descriptionInfo">
            <div class="col-4 mt-2 mb-5">
              <div class="input-group">
                <div class="form-group w-100">
                  <input type="text" class="form-control modal-text-box" formControlName="description" [attr.required]="true" />
                  <label class="label-control">{{ "Description" | translate }}</label>
                </div>
              </div>
            </div>
            <div class="col-4 mt-2 mb-5">
              <div class="input-group">
                <div class="form-group w-100">
                  <input type="text" class="form-control modal-text-box" [matAutocomplete]="assestPList" formControlName="project" [attr.required]="true" />
                  <label class="label-control">{{ settings.projectLabel | translate }}{{ " Name" | translate }}</label>
                  <mat-autocomplete #assestPList="matAutocomplete">
                    <mat-option *ngFor="let project of projectArr | sortAlpha : 'projectname' | globalSearch : assetForm.get('descriptionInfo.project')?.value" [value]="project.projectname">
                      {{ project.projectname | translate }}
                    </mat-option>
                  </mat-autocomplete>
                </div>
              </div>
            </div>
          </ng-container>

          <div class="col-4 mt-2 mb-5">
            <div class="input-group">
              <div class="form-group w-100">
                <input type="text" class="form-control modal-text-box" formControlName="session" [attr.required]="true" />
                <label class="label-control">{{ "Session" | translate }}</label>
              </div>
            </div>
          </div>

          <div class="col-4 mt-3 mb-5">
            <div class="input-group">
              <div class="form-group w-100">
                <input type="text" class="form-control modal-text-box" formControlName="episode" [attr.required]="true" />
                <label class="label-control">{{ "Episode" | translate }}</label>
              </div>
            </div>
          </div>
          <div class="col-4 mt-2 mb-5">
            <div class="input-group">
              <div class="form-group w-100">
                <input type="text" class="form-control modal-text-box" formControlName="client" [attr.required]="true" />
                <label class="label-control">{{ "Client" | translate }}{{ "/Studio" | translate }}</label>
              </div>
            </div>
          </div>

          <div class="col-4 mt-2 mb-5">
            <div class="input-group">
              <div class="form-group w-100">
                <select class="form-control modal-text-box" formControlName="company" [attr.required]="true">
                  <option [ngValue]="null">-- {{ "Select" | translate }} {{ settings.companyLabel | translate }} --</option>
                  <option *ngFor="let company of dropdownAssetData.companies | sortAlpha : 'name'" value="{{ company.id }}">{{ company.name | translate }}</option>
                </select>
                <label class="label-control">{{ settings.companyLabel | translate }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="form-content">
          <div class="attachment-content mt-2" style="height: 100px !important; padding-top: 14px !important">
            <i class="fa fa-upload"></i>
            <label for="">{{ "Drag Here" | translate }}</label>
            <label for="">{{ "or Browse your computer" | translate }}</label>
            <input type="file" class="fileType" (change)="onProfilePictureChange($event)" />
          </div>
          <span *ngIf="addedPictureNameMessage" style="color: hsl(147, 78%, 18%); text-align: left; font-size: 14px; margin-top: 5pt">{{ addedPictureNameMessage | translate }}</span>
          <span *ngIf="invalidPhotoFormatError" style="color: #a94442; text-align: left; font-size: 14px; margin-top: 5pt">{{ invalidPhotoFormatError | translate }}</span>
        </div>
        <div class="added-value-content" *ngIf="pictureUrl">
          <div class="added-value mt-15">
            <img [src]="pictureUrl" alt="" class="mr-3 img-fluid" title="{{ 'View Document' | translate }}" width="50px" />
            <label>
              <span>{{ profilePictureName }}</span>
            </label>
            <a href="javascript:void(0)" class="close text-danger font-14" title="{{ 'Remove Document' | translate }}" style="background-color: transparent !important; box-shadow: none !important; right: -12px !important; line-height: 0 !important" (click)="removePicture()">&#10005;</a>
            <!-- <div class="circlestatus cursor-p" (click)="openPdfModel(attachment)">
                                 <div class="circleBox" id="circlestatus" title="  {{'Preview'| translate}}" [ngStyle]="{'border-color': '#2f6f98','background-color': '#2f6f98', 'color': '#fff'}" >
                                     <span>
                                         {{'Preview'| translate}}
                                     </span>
                                 </div>
    
                             </div> -->
          </div>
        </div>
      </div>
    </div>
  </form>

  <button class="delete-btn-lt" *ngIf="hideDelete" (click)="deleteAsset()"><i class="fas fa-trash-alt"></i>{{ "Delete" | translate }}</button>
  <button class="submit-btnTop-rt" (click)="saveAsset()">{{ "Save & close" | translate }}</button>
</div>
